export const CampaignEvent = {
  MissionTaskListSelectClick: 'mission_task_list_select_click',
  MissionTypeTabClick: 'mission_type_tab_click',
} as const;

export interface CampaignEventDataType {
  [CampaignEvent.MissionTaskListSelectClick]: {
    event_location: string;
    slug: string;
    list_order: number;
    mission_id: string;
  };
  [CampaignEvent.MissionTypeTabClick]: {
    event_location: string;
    slug: string;
    list_order: number;
  };
}
